// extracted by mini-css-extract-plugin
export default {"row":"BxS_LTYFzkXuOKOHzb5D","column":"F_qGurOQDNpwmAhj0hJf"};